import { createAsyncThunk } from "@reduxjs/toolkit";
// import { add, subtract } from "_src/utils/math";
import { addFavorites, delFavorites } from "_src/servers/v1/common";

export const favoritesAsync = createAsyncThunk(
  "detail/fetchFavorites",
  async (data, { getState, rejectWithValue }) => {
    const {
      detail: { favorites },
    } = getState();

    const { flag } = data;
    let res = null;

    try {
      if (flag) {
        res = await addFavorites(data);
      } else {
        res = await delFavorites(data);
      }
    } catch (error) {
      console.log(error);
      rejectWithValue(favorites);
    }

    let count = favorites;
    if (res && res.code == 1000) {
      if (flag) {
        count += 1;
      } else {
        count -= 1;
      }
    }
    return count;
  }
);
